import apiSlice from 'app/apiSlice';
import { createEntityAdapter } from '@reduxjs/toolkit';
import { sortToString } from 'helpers/paramHelpers';

// Create an entity adapter for users
const companyParamsAdapter = createEntityAdapter();

const companyParamsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCompanyParams: builder.query({
      query: params => ({
        url: `company_params`,
        params: {
          ...params,
          sort: sortToString(params.sort || []),
        },
      }),
      transformResponse: response => {
        const normalized = companyParamsAdapter.setAll(
          companyParamsAdapter.getInitialState(),
          response.data || []
        );

        const restructured = {
          ...normalized,
          entities: normalized.ids.map(id => normalized.entities[id]), // Keep the order
        };

        return {
          ...response,
          data: restructured,
        };
      },
      providesTags: ['CompanyParams'], //tag for refetch when invalidateTags api trggered
    }),

    getCompanyParamById: builder.query({
      query: id => ({
        url: `company_params/${id}`,
      }),
      providesTags: ['CompanyParam'], //tag for refetch when invalidateTags api trggered
      invalidatesTags: ['CompanyParams'], //trigger refetch for the providesTags api
    }),

    createCompanyParam: builder.mutation({
      query: data => ({
        url: 'company_params',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['CompanyParams'], //trigger refetch for the providesTags api
    }),

    updateCompanyParam: builder.mutation({
      query: ({ id, data }) => ({
        url: `company_params/${id}`,
        method: 'PUT',
        body: data,
      }),

      invalidatesTags: ['CompanyParams', 'CompanyParam'], //trigger refetch for the providesTags api
    }),
  }),
  overrideExisting: false, // Avoid overwriting existing endpoints
});

export const {
  useGetCompanyParamsQuery,
  useGetCompanyParamByIdQuery,
  useCreateCompanyParamMutation,
  useUpdateCompanyParamMutation,
} = companyParamsApi;

export default companyParamsApi;
